// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"a787bbef","856":"97c913ca","952":"cfabdbff"}[chunkId] + ".chunk.js";
};